module.exports = __webpack_public_path__ + "media/bootstrap-icons/github-1dbcf7b2.svg";